import React, { Component } from 'react';
import './PrimaryButtonCardFitContent.scss';
import { connect } from 'react-redux';

class PrimaryButtonCardFitContent extends Component<{ text: string, icon: any, action?: any, currentLine: any }, { selected: boolean }> {

  constructor(props: any) {
    super(props);
    this.state = {
      selected: false
    }
  }
  /**
   * Main render method
   */
  render() {
    return (
      <div className={this.props.currentLine == this.props.text ? "primary-button-card-fit-active" : "primary-button-card-fit"} onClick={() => {
        if (this.props.action) {
          this.props.action();
        }
      }}>
        <div className="container">
          <img className="button-img" src={this.props.icon} alt="icon" />
        </div>
        <div className="button-text">{this.props.text}</div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    currentLine: state.texttospeech.currentLine
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {

  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrimaryButtonCardFitContent);